export default {
  // Set topics loaded state to true
  topicsTimestamp(state) {
    state.topicsLoaded = String(Math.round(new Date().getTime() / 1000));
  },
  // Reset topics timestamp
  topicsTimestampReset(state) {
    state.topicsLoaded = null;
  },
  // Set content state
  content(state, payload) {
    state.content = payload;
  },
  // Set categories state
  categories(state, payload) {
    state.categories = payload;
  },
  // Set topics state
  topics(state, payload) {
    state.topics = payload;
  },
};
